<script>
import CustomFieldsCrudList from '@app/components/CustomFieldsCrudList.vue';

export default {
  components: { CustomFieldsCrudList },
  data: () => ({
    isLoading: false,
    options: {
      enabled: false,
      fields: [],
    },
  }),
  computed: {
    authStore() {
      return this.$store.getters['auth/store'];
    },
  },
  created() {
    const opts = this.authStore && this.authStore.custom_fields_options;
    if (opts) {
      this.options = {
        enabled: !!opts.enabled,
        fields: Array.isArray(opts.fields)
          ? opts.fields.map((f) => ({
            name: f.name,
            label: f.label,
            type: f.type,
            required: !!f.required,
            options: Array.isArray(f.options) ? [...f.options] : [],
          }))
          : [],
      };
    }
  },
  methods: {
    handle(newOptions) {
      this.options = newOptions;
      this.isLoading = true;
      return this.$store.dispatch('auth/updateStoreCustomFields', newOptions)
        .then(() => this.$showMessage.success())
        .catch((err) => {
          const errors = err.response?.data?.errors;
          if (errors && typeof errors === 'object') {
            const messages = Object.values(errors).flat().join('<br>');
            this.$showMessage.error(messages);
          } else {
            this.$showMessage.error();
          }
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<template>
  <AppFeatureWrapper>
    <template #title>
      Formulaire d'inscription
      <AppFeatureBadge class="ml-2" position="is-right" planLock="EXPERT" />
    </template>
    <template #content>
      <p>
        Le nom, prénom et adresse e-mail sont déjà demandés lors de la création du compte apprenant.
        Ajoutez ici des questions supplémentaires si nécessaire (numéro de matricule, fonction...).
      </p>
      <p>
        Ces informations sont modifiables à tout moment par l'apprenant et le formateur.
        Retrouvez les réponses dans le profil de chaque apprenant et exportez-les.
      </p>
      <p>
        Attention aux informations que vous demandez :
        la collecte de données sensibles est interdite et reste sous votre entière responsabilité,
        conformément à notre politique de confidentialité.
      </p>
    </template>
    <template #form>
      <div class="box is-relative">
        <GoProWrapper planLock="EXPERT" :hasSep="false">
          <CustomFieldsCrudList
            v-model="options"
            :is-loading="isLoading"
            @save="handle"
          />
        </GoProWrapper>
      </div>
    </template>
  </AppFeatureWrapper>
</template>
